import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div>
            <ol>
                <li>
                    <h4><b>Introduction</b></h4>
                    <p>
                        This <b>Privacy Policy</b> outlines how the 
                        <b> International Journal of Interdisciplinary Studies and System Science (IJISSS)</b> 
                        collects, uses, and protects user information. By using our website and services, you agree 
                        to the collection and use of information in accordance with this policy.
                    </p>
                </li>

                <br />

                <li>
                    <h4><b>Information We Collect</b></h4>
                    <p>We may collect the following types of information:</p>
                    <ul>
                        <li>
                            <b>Personal Information:</b> Name, email address, affiliation, and contact details 
                            (collected during manuscript submission, reviewer registration, or inquiries).
                        </li>
                        <li>
                            <b>Manuscript Data:</b> Research articles, author details, and submission metadata.
                        </li>
                        <li>
                            <b>Technical Data:</b> IP addresses, browser type, and usage statistics for website analytics.
                        </li>
                    </ul>
                </li>

                <br />

                <li>
                    <h4><b>How We Use Your Information</b></h4>
                    <p>We use collected information to:</p>
                    <ul>
                        <li>Process manuscript submissions and <b>peer reviews</b>.</li>
                        <li>Communicate with <b>authors, reviewers, and editors</b>.</li>
                        <li>Improve our website’s functionality and <b>user experience</b>.</li>
                        <li>Comply with legal and ethical <b>publication standards</b>.</li>
                    </ul>
                </li>

                <br />

                <li>
                    <h4><b>Data Protection and Security</b></h4>
                    <ul>
                        <li>We implement appropriate <b>security measures</b> to protect user data.</li>
                        <li>Access to personal information is restricted to <b>authorized personnel</b>.</li>
                        <li>
                            Despite security efforts, <b>data transmission over the internet is not 100% secure</b>.
                        </li>
                    </ul>
                </li>

                <br />

                <li>
                    <h4><b>Sharing and Disclosure of Information</b></h4>
                    <ul>
                        <li>The journal does not sell or share personal data with third parties for marketing purposes.</li>
                        <li>
                            Information may be shared with indexing databases, legal authorities, 
                            or funding agencies when required.
                        </li>
                        <li>
                            Authors' names, affiliations, and research content are publicly available once published.
                        </li>
                    </ul>
                </li>

                <br />

                <li>
                    <h4><b>Cookies and Tracking Technologies</b></h4>
                    <ul>
                        <li>The website uses <b>cookies</b> to enhance user experience and track visitor behavior.</li>
                        <li>
                            Users can <b>disable cookies</b> in their browser settings, but this may affect functionality.
                        </li>
                    </ul>
                </li>

                <br />

                <li>
                    <h4><b>Data Retention Policy</b></h4>
                    <ul>
                        <li>
                            Personal information is <b>retained as long as necessary</b> for publication, 
                            research integrity, and record-keeping.
                        </li>
                        <li>
                            Authors may request <b>data deletion</b> if legally and ethically permissible.
                        </li>
                    </ul>
                </li>

                <br />

                <li>
                    <h4><b>Changes to the Privacy Policy</b></h4>
                    <ul>
                        <li>The journal may <b>update this Privacy Policy</b> periodically.</li>
                        <li>Users are encouraged to <b>review this policy regularly</b>.</li>
                    </ul>
                </li>
            </ol>

            <p>For any privacy-related concerns, contact us at: <b>[journal email]</b></p>
        </div>
    )
}

export default PrivacyPolicy
